export default __webpack_public_path__ + "static/media/rosana-rodrigues.68139690.ogg";